<div>
  <div class="instruction-text">
    <p>ONLY select the SMS Provider(s) (OPAs) that you use or intend to use. You can update this selection later if required.</p>
    <p>
      DO NOT select those you do not use. A SenderID may be handled by multiple SMS Providers (OPAs), but normally by no more than five. In the event
      that more than five SMS Providers (OPAs) are authorised, we may request further information to ensure the selection was what was intended.
      Failure to provide further information may lead to your SenderID application being rejected or revoked.
    </p>
  </div>

  <mat-form-field subscriptSizing="dynamic" class="dialog__filter">
    <mat-label>Search...</mat-label>
    <input type="text" matInput [formControl]="filter" />
  </mat-form-field>

  <div class="dialog__list-container">
    @for (opa of _filtredOpas; track opa; let i = $index) {
      <div class="dialog__checkbox-container">
        <mat-checkbox [formControl]="getFormControl(opa.accountId)">
          {{ opa.organisationName }}
        </mat-checkbox>
      </div>
    }
  </div>
  @if (hasOpasFormGroupError) {
    <mat-error>At least 1 OPA must be selected</mat-error>
  }
</div>
